import { Plus } from 'lucide-react';
import { useEditor } from './EditorContext';
import { TEMPLATES } from './HabitEditor';
import { Sticker } from './Sticker';

/** First start: a warm welcome with one-tap suggestions. */
export function EmptyState() {
  const editor = useEditor();
  return (
    <section className="empty glass">
      <Sticker id="wave" size={150} className="empty__sticker" />
      <h2 className="empty__title">Was möchtest du dir angewöhnen?</h2>
      <p className="empty__text">Lege dein erstes Habit an und hake es jeden Tag ab. Kleine Schritte, große Wirkung.</p>
      <div className="chips chips--center">
        {TEMPLATES.slice(0, 6).map((t) => (
          <button key={t.name} type="button" className={`chip hc-${t.color}`} onClick={() => editor.openNew(t)}>
            <span aria-hidden="true">{t.emoji}</span> {t.name}
          </button>
        ))}
      </div>
      <button type="button" className="btn btn--primary" onClick={() => editor.openNew()}>
        <Plus size={18} /> Eigenes Habit anlegen
      </button>
    </section>
  );
}
